import React from 'react';
import HomeTwoMain from './HomeTwoMain';
import Header from '../../components/Header';
import FooterThree from '../../components/Footer/FooterThree';

const HomeTwo = () => {
  return (
    <>
      <Header parentMenu="home" />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <HomeTwoMain />
          <FooterThree />
        </div>
      </div>
    </>
  );
};

export default HomeTwo;
